import { c as _c } from "react/compiler-runtime";
import { VenetianMask } from "lucide-react";
export function MaskingBadge() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="relative flex w-fit cursor-default items-center gap-2"><VenetianMask className="text-muted-foreground h-8 min-h-8 w-8 min-w-8" /><span className="text-base whitespace-nowrap">Confidential</span></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}